import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const Starburst = (props)=>/*#__PURE__*/ jsxs("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_7015_22040)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M13.8838 10.351L11.7985 14.1663C11.7116 14.3243 11.5826 14.4533 11.4272 14.5376L7.61199 16.6229C6.96164 16.9784 6.9853 17.7209 7.63565 18.0737L11.4272 20.3513C11.5852 20.4381 11.7142 20.5672 11.7985 20.7225L13.8838 24.5378C14.2393 25.1881 15.1713 25.1881 15.5268 24.5378L17.6122 20.7225C17.6991 20.5645 17.8281 20.4355 17.9834 20.3513L21.7987 18.2659C22.449 17.9104 22.449 16.9784 21.7987 16.6229L17.9834 14.5376C17.8254 14.4507 17.6965 14.3216 17.6122 14.1663L15.5268 10.351C15.1713 9.70069 14.2393 9.70069 13.8838 10.351Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M4.181 5.96943L2.88815 8.33125C2.83549 8.42867 2.75389 8.50766 2.65647 8.56295L0.294661 9.85576C-0.108191 10.0769 -0.0923803 10.5351 0.307839 10.7563L2.65647 12.1676C2.75389 12.2202 2.83285 12.3018 2.88815 12.3993L4.181 14.7611C4.40217 15.1639 4.97877 15.1639 5.19731 14.7611L6.49016 12.3993C6.54282 12.3018 6.62442 12.2228 6.72184 12.1676L9.08365 10.8747C9.4865 10.6536 9.4865 10.0769 9.08365 9.8584L6.72184 8.56558C6.62442 8.51292 6.54546 8.4313 6.49016 8.33388L5.19731 5.97206C4.97614 5.56921 4.39954 5.56921 4.181 5.97206V5.96943Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M20.5399 1.27411L19.2471 3.63593C19.1945 3.73335 19.1128 3.81235 19.0154 3.86764L16.6536 5.16045C16.2507 5.38163 16.2665 5.83977 16.6668 6.06094L19.0154 7.47224C19.1128 7.5249 19.1918 7.60653 19.2471 7.70395L20.5399 10.0658C20.7611 10.4686 21.3377 10.4686 21.5563 10.0658L22.8491 7.70395C22.9017 7.60653 22.9834 7.52753 23.0808 7.47224L25.4426 6.17943C25.8455 5.95826 25.8455 5.38163 25.4426 5.16308L23.0808 3.87027C22.9834 3.81761 22.9044 3.73599 22.8491 3.63857L21.5563 1.27675C21.3351 0.873896 20.7585 0.873896 20.5399 1.27675V1.27411Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_7015_22040",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "26",
                        height: "26",
                        fill: "white"
                    })
                })
            })
        ]
    });
const Starburst_Starburst = Starburst;
export { Starburst_Starburst as default };
